module.exports = __webpack_public_path__ + "img/the-social-mercenary.a8c452a8.webp";